export default __webpack_public_path__ + "c9ac0b37e052c2ca68a8077d9841f42c.png";